export const SET_CURRENT_TRIPS = 'SET_CURRENT_TRIPS';

export const actionSetCurrentTrips = trips => ({
    type: SET_CURRENT_TRIPS,
    payload: trips
})
